export const isRacerAccessFailure = (error: unknown): boolean =>
  /^(functions\/)?(permission-denied|unauthenticated|not-found)$/.test(String((error as { code?: unknown })?.code));
